import { ChatSession } from '../../_config/interfaces/interfaces';

interface ChatHistoryState {
  sessions: ChatSession[];
  loading: boolean;
}

const initialState: ChatHistoryState = {
  sessions: [],
  loading: false,
};

const chatHistoryReducer = (state = initialState, action: any): ChatHistoryState => {
  switch (action.type) {
    case 'CHAT_SESSIONS/SET':
      return { ...state, sessions: action.payload, loading: false };
    case 'CHAT_SESSIONS/LOADING':
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};

export default chatHistoryReducer;
